import { withInstall } from '@code-monkey-ui/utils'

import Tag from './src/tag.vue'

export const ElTag = withInstall(Tag)
export default ElTag

export * from './src/tag'
